export default __webpack_public_path__ + "static/media/first.e5640ca5.m4a";